import { fromJS } from 'immutable';
import { handleActions } from 'redux-actions';

import {
  compDidCatchError,
} from 'shared/actions/debug';
import { processError } from 'shared/helpers';


// Under top level key 'debug'.
const initialState = fromJS({
  errors: [],
});


export default handleActions({
  [compDidCatchError]: (state, action) => {
    const { payload } = action;
    const entry = processError(payload);

    return state.updateIn(['errors'], val => val.unshift(entry));
  },

}, initialState);



// WEBPACK FOOTER //
// ./src/shared/reducers/debug.js